import { render, staticRenderFns } from "./prize-toast.vue?vue&type=template&id=25343918&scoped=true&"
import script from "./prize-toast.vue?vue&type=script&lang=js&"
export * from "./prize-toast.vue?vue&type=script&lang=js&"
import style0 from "./prize-toast.vue?vue&type=style&index=0&id=25343918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25343918",
  null
  
)

export default component.exports